import React from "react";
import { useSetting, useSettingsActions } from "./SettingsStore.tsx";
import { SelectButton } from "primereact/selectbutton";
import { ProbabilityQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The probability panel (ADR 0108 §1): the question and nothing else. The
 * spinner and the bag are drawn at a size that reads, so there is no dial.
 * Basic tier, as the format's own panel is (ADR 0023 §2). Reads its own slice
 * of the settings (ADR 0081), so a change elsewhere on the panel does not
 * redraw it.
 */
export const ProbabilitySettings = React.memo(function ProbabilitySettings() {
    const { getSettings, setSettings } = useSettingsActions();
    const { question, language } = useSetting((settings) => ({
        question: settings.ProbabilityQuestion,
        language: settings.Language,
    }));
    const t = useTranslation();

    function handleQuestionChange(value: ProbabilityQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...getSettings(), ProbabilityQuestion: value });
    }

    return (
        <div className="probabilitySettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={question}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(ProbabilityQuestionOptions), language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
        </div>
    );
});

export default ProbabilitySettings;
